/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserRole,
    UserRoleFromJSON,
    UserRoleFromJSONTyped,
    UserRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserRoleDataFrame
 */
export interface UserRoleDataFrame {
    /**
     * 
     * @type {number}
     * @memberof UserRoleDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UserRoleDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof UserRoleDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof UserRoleDataFrame
     */
    data: Array<UserRole>;
}

export function UserRoleDataFrameFromJSON(json: any): UserRoleDataFrame {
    return UserRoleDataFrameFromJSONTyped(json, false);
}

export function UserRoleDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRoleDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(UserRoleFromJSON)),
    };
}

export function UserRoleDataFrameToJSON(value?: UserRoleDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(UserRoleToJSON)),
    };
}


